import React, {Component} from 'react'
import {batch, connect} from 'react-redux'

import FPSStats from 'react-fps-stats'

import Content from '@/components/Content/Content.js'

import Rectangle from '@/components/Rectangle/Rectangle.js'
import Grid from '@/components/Grid/Grid.js'

import PlatformEventInterface from '@/components/PlatformEventInterface/PlatformEventInterface.js'
// import PanZoomEventToAction from '@/components/PanZoomEventToAction/PanZoomEventToAction.js';
// import animatedZoomApi from '@/components/PanZoomEventToAction/animatedZoomApi.js';
// import SelectEventToAction from '@/components/SelectEventToAction/SelectEventToAction.js';
// import ResizeEventToAction from '@/components/ResizeEventToAction/ResizeEventToAction.js';
// import MarqueeToolAction from '@/components/MarqueeToolAction/MarqueeToolAction.js';
import Resize from '@/components/Resize/Resize';
import SelectIndicator from '@/components/SelectIndicator/SelectIndicator';
import Version from '@/components/Version/Version';
import Toolbar from '../Toolbar/Toolbar';
import Navigator from '@/components/NavigatorPixi/NavigatorPixi';
import AlignmentGuides from '@/components/AlignmentGuides/AlignmentGuides';
import ZoomToolbar from '@/components/ZoomToolbar/ZoomToolbar';

import contentActions from '@/action/content'
import cursorActions from '@/action/cursor'
import panZoomActions from '@/action/panZoom'
import editActions from '@/action/edit'
import selectionActions from '@/action/selection'
import toolActions from '@/action/tools'
import hoverActions from '@/action/hover'
import notecardActions from '@/action/notecard'

import { defaultZoom } from '@/reducer/camera';

import {clamp, getBounds, getIntersects} from '@/util/bounds.js'
import {getPanForZoom, getZoomIn, getZoomOut, MAX_ZOOM, MIN_ZOOM, scaleToZoom, zoomToScale} from '@/util/zoom.js'

import EventTarget from '@/util/EventTarget.js'
import { findUpTagByClass } from '@/util/findUpTag.js'

import resizeStyles from '@/components/Resize/Resize.module.css';


import ZoomHandler from '@/toolHandler/ZoomHandler/ZoomHandler';
import SelectHandler from '@/toolHandler/SelectHandler/SelectHandler';
import PanHandler from '@/toolHandler/PanHandler/PanHandler';
import MarqueeHandler from '@/toolHandler/MarqueeHandler/MarqueeHandler';
import NotecardHandler from '@/toolHandler/NotecardHandler/NotecardHandler';
import animatedZoomApi from '@/toolHandler/animatedZoomApi'


import { getAlignments, HORIZONTAL, VERTICAL } from '@/util/alignment.js';


// import GestureInterface, { GestureInterfaceComponent } from '@/components/GestureInterface/GestureInterface.js';

import { gridConfig } from '@/data/gridConfig';
import { AlignmentGuidesComponent } from '../AlignmentGuides/AlignmentGuides'
// console.log('gridConfig', gridConfig);


const MIN_SPREAD = 20
const EASING_COEFFICIENT = 0.1;


const SELECT_COLOR = '#0072ff';
const HOVER_COLOR = '#999999';

const margin = 20;
// const panSpeed = .075
const panMargin = 150;
const maxPanSpeed = 10;//20;

const PANBY = 100;



class SelectPanZoomResize extends Component {
    constructor(props) {
        super(props);

        var win = window.parent;
        if (win == window) {
            const viewport = win.document.querySelector("meta[name=viewport]");
            console.log('viewport', viewport);
            viewport.setAttribute("content", "width=device-width, initial-scale=1, user-scalable=no, maximum-scale=1.0, minimum-scale=1.0");    
        }

        this.domRef = React.createRef();

        this.state = {
            isNavigating: false,
            isShowingAll: false
        };

        console.log('SelectPanZoomResize', props.scale, props.panX, props.panY)

/*
        panX: state.camera.pan.x, 
        panY: state.camera.pan.y,
        scale: state.camera.zoom,
*/


        this.directed = {
            scale: props.scale,
            x: props.panX,
            y: props.panY,
            offsetX: 0,
            offsetY: 0
        }
        this.current = {
            scale: props.scale,
            x: props.panX,
            y: props.panY
        }

        this.autoPan = {dx: 0, dy: 0};

        this.gestureStartScale = 0;

        this.loop = this.loop.bind(this);
        this.endAnimation = this.endAnimation.bind(this);
        this.startAnimation = this.startAnimation.bind(this);
        this.closeNavigator = this.closeNavigator.bind(this);

        this.isActive = true;
        this.rafId = 0;
        this.lastInvocationMs = 0;

        this.doResize = this.doResize.bind(this);

        this.selectIndicator = <SelectIndicator size="3"></SelectIndicator>;
        this.hoverIndicator = <SelectIndicator key="hover" size="3" color={HOVER_COLOR}></SelectIndicator>;
        this.resizeControl = <Resize key="resize"></Resize>;

        // this.animatedPanZoomComponent = <PanZoomEventToAction
        //     // ref={this.ref1}
        //     tweenZoom={animatedZoomApi.tweenZoom}
        //     tweenZoomUpdate={animatedZoomApi.tweenZoomUpdate}
        //     cancelTweenZoom={animatedZoomApi.cancelTweenZoom}
        // ></PanZoomEventToAction>;

        // this.nonAnimatedPanZoomComponent = <PanZoomEventToAction></PanZoomEventToAction>;        
    
        // console.log(this.animatedPanZoomComponent);

        this.tweenZoom=animatedZoomApi.tweenZoom.bind(this);
        this.tweenZoomToZ = animatedZoomApi.tweenZoomToZ.bind(this);
        this.tweenZoomUpdate=animatedZoomApi.tweenZoomUpdate.bind(this);
        this.cancelTweenZoom=animatedZoomApi.cancelTweenZoom.bind(this);


        let self = this;

        this.eventTarget = new EventTarget();

        this.handleGestureChanged = this.handleGestureChanged.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.resetModifierKeys = this.resetModifierKeys.bind(this);


        const zoomHandler = new ZoomHandler(this);
        const selectHandler = new SelectHandler(this);
        const panHandler = new PanHandler(this);
        const marqueeHandler = new MarqueeHandler(this);
        const notecardHandler = new NotecardHandler(this);

        this.toolHandler = {
            ZOOM: zoomHandler,
            SELECT: selectHandler,
            PAN: panHandler,
            MARQUEE: marqueeHandler,
            LASSO:  null,

            NOTECARD: notecardHandler,
            SHAPE: null,
            DRAW: null
        }
        


        // POINTER & TOUCH

        this.eventTarget.addEventListener('doubletap', function(event){

            let gestureTarget = event.detail.gestureStartTarget;
            console.log('EVENT:', 'doubletap', gestureTarget);
            const textfieldElement = findUpTagByClass(gestureTarget, 'Textfield');
            const isTextfield = textfieldElement !== null;
            if (isTextfield) {
                gestureTarget = textfieldElement;

                this.props.activate(gestureTarget.id);

            }
            // console.log('isTextfield', isTextfield, textfieldElement);

        }.bind(this));
        

        this.eventTarget.addEventListener('gesture-changed', this.handleGestureChanged);

        this.eventTarget.addEventListener('move-pointer-to', function(event){
            // console.log('move-pointer-to', event);
            self.pointerX = event.detail.x;
            self.pointerY = event.detail.y;
        });
        
        this.eventTarget.addEventListener('gesture-ended', function(event){
            self.gestureStartScale = 0;
            self.autoPan.dx = 0;
            self.autoPan.dy = 0;

            self.pointerHasLeftAutoPanMargin = false;
            // self.didDrag =  false;





            if (self.props.isGrabbing) {
                self.props.setCursor({
                    isGrabbing: false
                });
            }

            self.startAnimation();
        });

        // MOUSE WHEEL
        this.eventTarget.addEventListener('zoom-by', function(event) {
            console.log('wheel-zoom-by');
            // console.log('EVENT:', 'zoom- to!', self.directed.scale, event.detail.dz)

            let newScale;

            if (event.detail.pinnedToStart) {
                newScale = self.gestureStartScale * event.detail.dz
            } else {
                self.gestureStartScale = self.directed.scale;
                newScale = zoomToScale( scaleToZoom(self.directed.scale) + event.detail.dz);
            }

            // console.log('zoom to', newScale);
            self.directed.scale = newScale;            
            self.directed.offsetX = event.detail.x - self.props.width/2;
            self.directed.offsetY = event.detail.y - self.props.height/2;

            self.startAnimation();
        });        
        this.eventTarget.addEventListener('pan-by', function(event) {
            // console.log('wheel-pan-by')
            // self.props.panBy(x.detail.dx, x.detail.dy);
            // console.log('EVENT:', 'pan', event);
            self.directed.x = self.directed.x + event.detail.dx / self.current.scale;
            self.directed.y = self.directed.y + event.detail.dy / self.current.scale;

            self.directed.offsetX = 0
            self.directed.offsetY = 0

            self.startAnimation();
        });
    }

    componentDidMount() {
        global.addEventListener("keydown", this.handleKeyDown);
        global.addEventListener("keyup", this.handleKeyUp);

        global.addEventListener("focus", this.resetModifierKeys);
        global.addEventListener("blur", this.resetModifierKeys);

        this.handleToolChanged(null, this.props.currentTool);

        this.loop()
    }

    componentWillUnmount() {
        global.removeEventListener("keydown", this.handleKeyDown);
        global.removeEventListener("keyup", this.handleKeyUp);

        global.removeEventListener("focus", this.resetModifierKeys);
        global.removeEventListener("blur", this.resetModifierKeys);

        this.handleToolChanged(this.props.currentTool, null);

        this.endAnimation();
    }



    handleGestureChanged(event) {
        // console.log('handleGestureChanged');
        let gestureTarget = event.detail.gestureStartTarget;

        const textfieldElement = findUpTagByClass(gestureTarget, 'Textfield');
        const isTextfield = textfieldElement !== null;
        if (isTextfield) {
            gestureTarget = textfieldElement;
        }
        // console.log('isTextfield', isTextfield, textfieldElement);

        // console.log('gesture targ', gestureTarget);
        const isDraggable = gestureTarget && gestureTarget.classList.contains('draggable');
        const isResizeHandle = gestureTarget && gestureTarget.classList.contains(resizeStyles.handle);

        // console.log(
        //     'isDragable', gestureTarget.classList
        // )

        if (isResizeHandle)  {
            this.resizeHandle = gestureTarget.className.split(' ')[1];
            this.props.activate(this.resizeHandle);
        }



        // console.log('gesture-changed', 'isDraggable', isDraggable);
        // console.log('EVENT:', 'drag-changed', self.directed.scale, event.detail.current.spread, event.detail.previous.spread);
        
        const dx = event.detail.delta.pos.x / this.current.scale;
        const dy = event.detail.delta.pos.y / this.current.scale;

        // drag-to-pan
        // console.log('ev type', event.detail.type)
        if (event.detail.type == 'drag' && event.detail.coreTouchCount == 2 && event.detail.touchCount >= 2) {

            if (event.detail.gestureStartScale !== undefined) {
                // console.log ('xxx A');
                this.gestureStartScale = event.detail.gestureStartScale;
            } 
            
            if (this.gestureStartScale == 0) {
                // console.log ('xxx B');
                this.gestureStartScale = this.current.scale;
            }

            let currentSpread = clamp(event.detail.current.spread, MIN_SPREAD, Number.POSITIVE_INFINITY);
            let startSpread =   clamp(event.detail.start.spread,   MIN_SPREAD, Number.POSITIVE_INFINITY);

            let newScale = event.detail.touchCount >= 2 ? this.gestureStartScale * (currentSpread / startSpread) : this.directed.scale;

            this.directed.scale = clamp(newScale, MIN_ZOOM, MAX_ZOOM);
            
            this.directed.x += dx
            this.directed.y += dy;

            this.directed.offsetX = event.detail.current.pos.x - this.props.width/2;
            this.directed.offsetY = event.detail.current.pos.y - this.props.height/2;
        }

        if (event.detail.coreTouchCount == 1 && event.detail.touchCount == 1) {

            if (isResizeHandle || isDraggable) {

                if (
                  this.pointerHasLeftAutoPanMargin
                    ||
                  ((event.detail.start.pos.x > panMargin) && (event.detail.start.pos.x < this.props.width - panMargin)
                    && (event.detail.start.pos.y > panMargin) && (event.detail.start.pos.y < this.props.height - panMargin))
                || 
                  ((event.detail.current.pos.x > panMargin) && (event.detail.current.pos.x < this.props.width - panMargin)
                    && (event.detail.current.pos.y > panMargin) && (event.detail.current.pos.y < this.props.height - panMargin))

                ) {
                    this.pointerHasLeftAutoPanMargin = true;
                }

                if (this.pointerHasLeftAutoPanMargin || this.autoPan.dx) {
                    
                    if (event.detail.current.pos.x < panMargin) {
                        // console.log('pan!', this.autoPan, event.detail.current.pos.x)     
                        this.autoPan.dx = Math.min(maxPanSpeed, maxPanSpeed * (panMargin - event.detail.current.pos.x)/panMargin) / this.current.scale;
                    } else if (event.detail.current.pos.x > this.props.width - panMargin) {
                        // console.log('pan!', this.directed.x)
                        this.autoPan.dx = -Math.min(maxPanSpeed, maxPanSpeed * (panMargin - (this.props.width - event.detail.current.pos.x))/panMargin) / this.current.scale;
                    } else {
                        this.autoPan.dx = 0;
                    }
                }

                if (this.pointerHasLeftAutoPanMargin || this.autoPan.dy) {
                    if (event.detail.current.pos.y < panMargin) {
                        // console.log('pan!', this.directed.y)
                        this.autoPan.dy = Math.min(maxPanSpeed, maxPanSpeed * (panMargin - event.detail.current.pos.y)/panMargin) / this.current.scale;
                    } else if (event.detail.current.pos.y > this.props.height - panMargin) {
                        // console.log('pan!', this.directed.y)
                        this.autoPan.dy = -Math.min(maxPanSpeed, maxPanSpeed * (panMargin - (this.props.height - event.detail.current.pos.y))/panMargin) / this.current.scale;
                    } else {
                        this.autoPan.dy = 0;
                    }
                }
                // console.log(this.autoPan.dx, this.autoPan.dy);

                if (!this.props.isGrabbing) {
                    this.props.setCursor({
                        isGrabbing: true
                    });
                }
            } else {
                if (this.props.isGrabbing) {
                    this.props.setCursor({
                        isGrabbing: false
                    });
                }
            }

            const isTextfieldSelected = this.props.content.selection.length == 1 
            && 
            this.props.media.find((x)=>{

                return x.id == this.props.content.selection[0]}).type == 'text';


            if (this.resizeHandle) {
                // content to screen
                // const screenx = this.props.width/2 + (this.props.panX + contentX) * this.props.scale;
                // const screeny = this.props.height/2 + (this.props.panY + contentY) * this.props.scale;

                // screen to content
                const cursorX = ((event.detail.current.pos.x - this.props.width/2) / this.props.scale) - this.props.panX;
                const cursorY = ((event.detail.current.pos.y - this.props.height/2) / this.props.scale) - this.props.panY;

                if (isTextfieldSelected) {
                    // console.log('isTextfieldSelected', isTextfieldSelected);//
                }

                // isTextfieldSelected ? false : 
                let isAspectLocked = this.props.aspectLock; // if textfield, no aspect lock

                this.doResize(
                    isAspectLocked,
                    this.resizeHandle,
                    dx,
                    dy,
                    cursorX,
                    cursorY
                );
            } else {
                this.props.deactivate(this.resizeHandle);
                this.resizeHandle = null;
            }
/*
            if (this.props.currentTool == 'PAN') {
                this.directed.x += dx;
                this.directed.y += dy;
            } else if (this.props.currentTool == 'SELECT') {
                console.log('gesture-changed single finger', 'isDraggable', isDraggable, 'isResizeHandle', isResizeHandle, dx, dy);
                //AUTOPAN?

                // let autoPan = {dx: 0, dy:0 };

                //  || state.isKeyboardPanning
                // isResizeHandle

                //
                // const isSelected = this.props.content.selection.indexOf(id)
                //
                // && 
                // this.props.media.find((x)=>{return x.id == this.props.content.selection[0]}).type == 'text';

                const isActiveTextfieldSelected = isTextfieldSelected 
                    &&  this.props.content.selection[0] == this.props.content.active[0];

                console.log('isActiveTextfieldSelected', isActiveTextfieldSelected)

                if (!isActiveTextfieldSelected && isDraggable && (dx !== 0 || dy !== 0)) {
                    this.didDrag =  true;
                    console.log('drag')
                    this.props.moveSelection(
                        dx,
                        dy
                    );
                } else {
                    // console.log("[[[  HELP!  ]]]")
                    this.didDrag =  false;
                }

            }
 */
        } else {
            if (this.props.isGrabbing) {
                this.props.setCursor({
                    isGrabbing: false
                });
            }
        }

        this.startAnimation();
    }


    handleKeyDown(e) {
        console.log(e.code, e.keyCode, this.props.currentTool);
        
        // let handled = true;
        if (this.props.currentTool == 'SELECT') {
            if (
                e.code === 'Space' || e.which === 32
                // ||
                // (navigator.userAgent.indexOf('Mac OS X') != -1 && (e.code === 'Meta' || e.which === 91))
                // ||
                // (navigator.userAgent.indexOf('Mac OS X') == -1 && (e.code === 'Control' || e.which === 17))
            ) {
                console.log(navigator.userAgent, e.code, e.which)

                this.props.setToolModifier({
                    space: true
                })

                if (!this.props.isGrabbable) {
                    this.props.setCursor({
                        isGrabbable: true
                    });
                }

            }
        } 
        
        if (!this.props.multiselectIndicator) {
            if (e.code === 'Shift' || e.which === 16) {
                // this.setState({
                //     isShiftDown: true
                // });
                this.props.setToolModifier({
                    shift: true
                })
            }
        }




        if (navigator.userAgent.indexOf('Mac OS X') != -1) {
            if ((e.metaKey) && e.which === 187) {
                e.preventDefault();
                if (e.repeat) {
                    return;
                }
                this.directed.scale = getZoomIn(this.directed.scale, 1);
            } else if ((e.metaKey) && e.which === 189) {
                e.preventDefault();
                if (e.repeat) {
                    return;
                }
                this.directed.scale = getZoomOut(this.directed.scale, 1);
            }
        } else {
            if ((e.ctrlKey) && e.which === 187) {
                e.preventDefault();
                if (e.repeat) {
                    return;
                }
                this.directed.scale = getZoomIn(this.directed.scale, 1);
            } else if ((e.ctrlKey) && e.which === 189) {
                e.preventDefault();
                if (e.repeat) {
                    return;
                }
                this.directed.scale = getZoomOut(this.directed.scale, 1);
            }
        }


        const isTextfieldSelected = this.props.content.selection.length == 1 
        && 
        this.props.media.find((x)=>{return x.id == this.props.content.selection[0]}).type == 'text';
        
        const isActiveTextfieldSelected = isTextfieldSelected 
        &&  this.props.content.selection[0] == this.props.content.active[0];

        if (isActiveTextfieldSelected) {
            return
        }


        if (this.props.content.selection.length) {
            //const factor = 2;
            let distance = Math.max(1, Math.round(2 / this.directed.scale / 8) * 8);
            // console.log('scale', this.directed.scale, 'dis', distance)

            // MOVE
            if (e.code === 'ArrowLeft' || e.keyCode ===37) {
                this.props.moveSelection(
                    -(e.shiftKey ? 1 : 8) * distance,// / this.directed.scale,
                    0
                );
            } else if (e.code === 'ArrowRight' || e.keyCode ===39) {
                this.props.moveSelection(
                    (e.shiftKey ? 1 : 8) * distance,// / this.directed.scale,
                    0
                );
            } else if (e.code === 'ArrowUp' || e.keyCode ===38) {
                this.props.moveSelection(
                    0,
                    -(e.shiftKey ? 1 : 8) * distance,// / this.directed.scale
                );
            } else if (e.code === 'ArrowDown' || e.keyCode ===40) {
                this.props.moveSelection(
                    0,
                    (e.shiftKey ? 1 : 8) * distance,// / this.directed.scale
                );
            } 
        } else {
            // PAN
            if (e.code === 'ArrowLeft' || e.keyCode ===37) {
                if (e.shiftKey) {
                    this.directed.x += 10 / this.directed.scale;
                } else {
                    this.directed.x += PANBY / this.directed.scale;
                }
            } else if (e.code === 'ArrowRight' || e.keyCode ===39) {
                if (e.shiftKey) {
                    this.directed.x -= 10 / this.directed.scale;
                } else {
                    this.directed.x -= PANBY / this.directed.scale;
                }
            } else if (e.code === 'ArrowUp' || e.keyCode ===38) {
                if (e.shiftKey) {
                    this.directed.y += 10 / this.directed.scale;
                } else {
                    this.directed.y += PANBY / this.directed.scale;
                }
            } else if (e.code === 'ArrowDown' || e.keyCode ===40) {
                if (e.shiftKey) {
                    this.directed.y -= 10 / this.directed.scale;
                } else {
                    this.directed.y -= PANBY / this.directed.scale;
                }
            } 
        }



        // pendoTracker.add({
        //     type: 'keydown',
        //     key: e.code || e.which
        // });
    }
    handleKeyUp(e) {
        // console.log('up', e);

        if (
            e.code === 'Space' || e.which === 32
            // ||
            // (navigator.userAgent.indexOf('Mac OS X') != -1 && (e.code === 'Meta' || e.which === 91))
            // ||
            // (navigator.userAgent.indexOf('Mac OS X') == -1 && (e.code === 'Control' || e.which === 17))
            ) {
            this.props.setToolModifier({
                space: false
            })
            this.props.setCursor({
                isGrabbable: false
            });
        } 
        
        if (e.code === 'Shift' || e.which === 16) {
            // this.setState({
            //     isShiftDown: false
            // });
            this.props.setToolModifier({
                shift: false
            })
        }

        // pendoTracker.add({
        //     type: 'keyup',
        //     key: e.code || e.which
        // });
    }

    resetModifierKeys () {
        // console.log('reset modifier keys');
        this.props.setToolModifier({
            space: false
        })
        this.props.setToolModifier({
            shift: false
        })
    }

    closeNavigator () {
        this.isNavigatingTimeout = null;
        this.setState({
            isNavigating: false
        })
    }

    doResize (aspectLock, resizeHandle, dx, dy, cursorX, cursorY) {
        // console.log('doResize', this.props.content.selection)
        let xAxisNormal = 0, yAxisNormal = 0;

        const contentBounds = getBounds( this.props.media, this.props.content.selection );
        // console.log('contentBounds', contentBounds);
        const handleOffsetFactor = ((this.props.content.selection.length > 1) ? 26 : 13) / this.props.scale;

        let resizeHandleOppositeX, resizeHandleOppositeY;

        switch(resizeHandle) {
            case resizeStyles.nw:
                resizeHandleOppositeX = contentBounds.maxX - handleOffsetFactor;
                resizeHandleOppositeY = contentBounds.maxY - handleOffsetFactor;
                break;
            case resizeStyles.n:
                //
                resizeHandleOppositeX = aspectLock ? Number.POSITIVE_INFINITY : contentBounds.maxX - contentBounds.minX + cursorX; 
                resizeHandleOppositeY = contentBounds.maxY - handleOffsetFactor;
                break;
            case resizeStyles.ne:
                resizeHandleOppositeX = contentBounds.minX + handleOffsetFactor;
                resizeHandleOppositeY = contentBounds.maxY - handleOffsetFactor;
                break;
            case resizeStyles.w:
                resizeHandleOppositeX = contentBounds.maxX - handleOffsetFactor;
                //
                resizeHandleOppositeY = aspectLock ? Number.POSITIVE_INFINITY : contentBounds.maxY - contentBounds.minY + cursorY; 
                break;
            case resizeStyles.e:
                resizeHandleOppositeX = contentBounds.minX + handleOffsetFactor;
                // 
                resizeHandleOppositeY = aspectLock ? Number.POSITIVE_INFINITY : contentBounds.maxY - contentBounds.minY + cursorY; 
                break;
            case resizeStyles.sw:
                resizeHandleOppositeX = contentBounds.maxX - handleOffsetFactor;
                resizeHandleOppositeY = contentBounds.minY + handleOffsetFactor;
                break;
            case resizeStyles.s:
                // 
                resizeHandleOppositeX = aspectLock ? Number.POSITIVE_INFINITY : contentBounds.maxX - contentBounds.minX + cursorX; 
                resizeHandleOppositeY = contentBounds.minY + handleOffsetFactor;
                break;
            case resizeStyles.se:
                resizeHandleOppositeX = contentBounds.minX + handleOffsetFactor;
                resizeHandleOppositeY = contentBounds.minY + handleOffsetFactor;
                break;
            default:
                break;
        }

        const targetBounds = {
            width: Math.abs( cursorX - resizeHandleOppositeX),
            height: Math.abs( cursorY - resizeHandleOppositeY),
        }
        
        console.log('targetBounds', targetBounds); //, targetBounds.height / targetBounds.width);

        batch(() => {
            // console.log('resizeSelection', contentBounds, targetBounds);

            this.props.resizeSelection(
                contentBounds,
                targetBounds,
                resizeHandle,
                aspectLock
            );
    
            const id = this.props.content.selection[0];
            const item = this.props.media.find((x)=>{return x.id == id});//this.props.media[index];
            console.log(item);
    
            if (item && item.type == 'text' && aspectLock) {
                const currentScale = item.scale;
                const dw = (targetBounds.width- (0*item.scale))  / (contentBounds.maxX - contentBounds.minX - (0*item.scale));
                const dh = (targetBounds.height - (0*item.scale))/ (contentBounds.maxY - contentBounds.minY - (0*item.scale));
                // console.log(currentScale, dw, dh);
                const newScale = 1 * currentScale * Math.min(dw, dh);
                // console.log('resizeAction', id, newScale);
                this.props.setScale(id, newScale);
            }
        })
    }

    loop(time) {
        // console.log('loop')
        const { lastInvocationMs, throttleMs, isActive } = this;
        // const isAnimatable = !!(this.onAnimationFrame);

        // // Latter const is defensive check for React Native unmount (issues/#3)
        if (!isActive) return;

        // const hasTimeElapsed = !throttleMs || time - lastInvocationMs >= throttleMs;

        // if (hasTimeElapsed) {
        this.onAnimationFrame(time-lastInvocationMs);
        //     this.lastInvocationMs = time;
        // }

        // cancelAnimationFrame(this.rafId);
        this.rafId = requestAnimationFrame(this.loop);
        // 
    }

    endAnimation() {
        console.log('end');
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
        this.isActive = false;
    }

    startAnimation() {
        if (!this.isActive) {
            this.isActive = true;
            this.rafId = requestAnimationFrame(this.loop);
        }
    }


    // getComponentDebug() {
    //     return this.props.media ? this.props.media.map((item) => {

    //         return <Rectangle 
    //             key={`debug_${item.id}`}
    //             {...item}
    //             src={null}
    //             fg_color="#EE33FF"
    //             background="transparent"
    //         ></Rectangle>
    //     }) : []
    // }



    getEnv() {
        // return [];
        return this.props.env ? this.props.env.map((item) => {
            return <Rectangle 
                key={'rect-'+item.id}
                {...item}
            ></Rectangle>
        }) : []
    }
    


    getZoomToIndicator(bounds) {
        if (true) {
            //console.log("GET ZOOM TO INDICATOR", bounds);
            if (bounds.maxX - bounds.minX < 5
                || bounds.maxY - bounds.minY < 5)
            {
                return null;
            }

            const x = this.props.width/2 + (this.props.panX + bounds.minX) * this.props.scale;
            const y = this.props.height/2 + (this.props.panY + bounds.minY) * this.props.scale;
            const width = (bounds.maxX - bounds.minX) * this.props.scale;
            const height = (bounds.maxY - bounds.minY) * this.props.scale;

            return <div
                style={{
                    position: 'absolute',
                    border: '1px solid #006699',
                    background: 'rgba(255, 255, 255, 0.1)', //  '#006699',
                    left: x,
                    top: y,
                    width: width,
                    height: height,
                    pointerEvents: 'none',
                    // boxShadow: '0px 0px 2px 0px #000000, inset 0px 0px 2px 0px #000000'
                }}
            ></div>; 
        }
    }

    getMarqueeIndicator(bounds) {
        if (true) {
            // console.log("GET MARQUEE", bounds);
            if (bounds.maxX - bounds.minX < 5
                || bounds.maxY - bounds.minY < 5)
            {
                return null;
            }

            const x = this.props.width/2 + (this.props.panX + bounds.minX) * this.props.scale;
            const y = this.props.height/2 + (this.props.panY + bounds.minY) * this.props.scale;
            const width = (bounds.maxX - bounds.minX) * this.props.scale;
            const height = (bounds.maxY - bounds.minY) * this.props.scale;

            return <div
                style={{
                    position: 'absolute',
                    border: '1px solid #006699',
                    background: 'rgba(255, 255, 255, 0.1)', //  '#006699',
                    left: x,
                    top: y,
                    width: width,
                    height: height,
                    pointerEvents: 'none',
                    // boxShadow: '0px 0px 2px 0px #000000, inset 0px 0px 2px 0px #000000'
                }}
            ></div>; 
        }
    }

    getNotecardPreviewIndicator(bounds) {
        if (true) {
            // console.log("GET NOTE PREview", bounds);
            if (bounds.maxX - bounds.minX < 5
                || bounds.maxY - bounds.minY < 5)
            {
                return null;
            }

            const x = this.props.width/2 + (this.props.panX + bounds.minX) * this.props.scale;
            const y = this.props.height/2 + (this.props.panY + bounds.minY) * this.props.scale;
            const width = (bounds.maxX - bounds.minX) * this.props.scale;
            const height = (bounds.maxY - bounds.minY) * this.props.scale;

            return <div
                style={{
                    position: 'absolute',
                    border: '1px solid rgba(254, 244, 156, 1)',
                    background: 'rgba(254, 244, 156, 0.25)',
                    left: x,
                    top: y,
                    width: width,
                    height: height,
                    pointerEvents: 'none',
                    // boxShadow: '0px 0px 2px 0px #000000, inset 0px 0px 2px 0px #000000'
                }}
            ></div>; 
        }
    }


    getHighlight(bounds, size = 1 , color) {
        // console.log("GET HILIGHT", bounds);
        const x = this.props.width/2 + (this.props.panX + bounds.minX) * this.props.scale;
        const y = this.props.height/2 + (this.props.panY + bounds.minY) * this.props.scale;
        const width = (bounds.maxX - bounds.minX) * this.props.scale;
        const height = (bounds.maxY - bounds.minY) * this.props.scale;

        return <div
            style={{
                position: 'absolute',
                borderRadius: size + 'px',
                border: size + 'px solid ' + color,
                left: x - margin,
                top: y - margin,
                width: width + margin * 2,
                height: height + margin * 2,
                pointerEvents: 'none',

                // boxShadow: '0px 0px 5px 2px ' + color + ', inset 0px 0px 5px 2px ' + color
            }}
        ></div>;
    }

    getMultiResizeControl(bounds) {
        const x = this.props.width/2 + (this.props.panX + bounds.minX) * this.props.scale;
        const y = this.props.height/2 + (this.props.panY + bounds.minY) * this.props.scale;
        const width = (bounds.maxX - bounds.minX) * this.props.scale;
        const height = (bounds.maxY - bounds.minY) * this.props.scale;

        return <Resize key="resize"
            x={x}
            y={y}
            width={width}
            height={height}
            margin={25}
        ></Resize>;
    }

    onAnimationFrame(timeDelta) {
        // console.log('onAnimationFrame', timeDelta, this.didDrag)
        timeDelta = clamp(timeDelta, 10, 250);

        // console.log(timeDelta);

        // zoom is linear, while scale is log2
        let zoom = scaleToZoom(this.current.scale)
        let directedZoom = scaleToZoom(this.directed.scale)

        // console.log(zoom, directedZoom);

        let newScale = this.current.scale;
    
        // console.log('onAnimationFrame', timeDelta);// zoom, this.directed.scale, directedZoom);
        // apply easing
        let threshold = 0.01;//clamp((0.01 * directedZoom), 0.001, 1)
        let zoomErr = directedZoom - zoom ; //clamp(zoom - directedZoom, -10, 10); // 

        // console.log('zoomErr', zoomErr);

        this.directed.x += this.autoPan.dx;
        this.directed.y += this.autoPan.dy;
        
        if (this.didDrag && (this.autoPan.dx !== 0 || this.autoPan.dy !== 0)) {
            // console.log("*",1 );
            this.props.moveSelection(
                -this.autoPan.dx,
                -this.autoPan.dy
            );

            if (this.resizeHandle) {
                console.log("ANIMATED RESIZE?!")
                this.doResize(
                    true,
                    this.resizeHandle,
                    -this.autoPan.dx,
                    -this.autoPan.dy
                );    
            }
        }

        let dirty = false;

        if (Math.abs(zoomErr) > threshold
            || Math.abs(this.current.x - this.directed.x) > threshold
            || Math.abs(this.current.y - this.directed.y) > threshold)
        {
            // Lee liked these params
            // zoom -= timeDelta * ((0.00625 * zoomErr) + (0.0125 * zoomErr * zoomErr * zoomErr))

            zoom += timeDelta * EASING_COEFFICIENT * ((0.01 * zoomErr) + (0.0025 * zoomErr * zoomErr * zoomErr))

            // newScale = zoomToScale(zoom);
            newScale = clamp(zoomToScale(zoom), Math.min(this.current.scale, this.directed.scale), Math.max(this.current.scale, this.directed.scale));

            // console.log(`timeDelta: ${timeDelta}  err: ${zoomErr}, threshold: ${threshold}, new scale: ${newScale}`);

            // console.log('z', zoom, 'anim newScale', newScale, 'from', this.current.scale);

            // if (Math.abs(zoomErr) > threshold) {
                let pan = getPanForZoom(
                    this.directed.offsetX,
                    this.directed.offsetY,
                    this.current.scale,
                    newScale
                );
    
                // console.log('new pan', pan)
        
                this.directed.x += pan.dx;
                this.directed.y += pan.dy;
            // }

            // console.log(pan)

            this.current.scale = newScale;
            this.current.x = this.directed.x;
            this.current.y = this.directed.y;

            // console.log('dirty pan');
            dirty = true;
        } else if (this.current.scale !== this.directed.scale
            || this.current.x !== this.directed.x
            || this.current.y !== this.directed.y) 
        {
            // console.log("^", zoomErr, this.current.scale , this.directed.scale)
            this.current.scale = this.directed.scale;
            this.current.x = this.directed.x;
            this.current.y = this.directed.y;

            // console.log('dirty zoom');
            dirty = true;

            

        }
        
        if (dirty) {
            this.setState({
                isNavigating: true,
                isShowingAll: false,

                prevBounds: {
                    minX: -this.props.panX - (this.props.width/2 / this.props.scale),
                    minY: -this.props.panY - (this.props.height/2 / this.props.scale),
                    maxX: -this.props.panX + (this.props.width/2 / this.props.scale),
                    maxY: -this.props.panY + (this.props.height/2 / this.props.scale)                            
                }
                
            });

            if (this.isNavigatingTimeout) {
                clearTimeout(this.isNavigatingTimeout);
            }
            this.isNavigatingTimeout = setTimeout(this.closeNavigator, 2000);

            // console.log('anim zoom set current', this.current.scale, 'directed', this.directed.scale)

            batch(() => {
                this.props.setZoom(this.current.scale);
                this.props.setPan(this.current.x, this.current.y);
            })

        }


    }

    handleToolChanged(oldTool, newTool) {
        // console.log('handleToolChanged', oldTool, newTool);

        let oldToolHandler = this.toolHandler[oldTool]
        if (oldToolHandler){
            if (oldToolHandler.tap) {
                this.eventTarget.removeEventListener('tap', oldToolHandler.tap);
            }
            if (oldToolHandler.startdrag) {
                this.eventTarget.removeEventListener('gesture-started(drag)', oldToolHandler.startdrag);
            }
            if (oldToolHandler.change) {
                this.eventTarget.removeEventListener('gesture-changed', oldToolHandler.change);
            }
            if (oldToolHandler.enddrag) {
                this.eventTarget.removeEventListener('gesture-ended', oldToolHandler.enddrag);
            }
        }

        let newToolHandler = this.toolHandler[newTool]
        if (newToolHandler){
            if (newToolHandler.tap) {
                this.eventTarget.addEventListener('tap', newToolHandler.tap);
            }
            if (newToolHandler.startdrag) {
                this.eventTarget.addEventListener('gesture-started(drag)', newToolHandler.startdrag);
            }
            if (newToolHandler.change) {
                this.eventTarget.addEventListener('gesture-changed', newToolHandler.change);
            }
            if (newToolHandler.enddrag) {
                this.eventTarget.addEventListener('gesture-ended', newToolHandler.enddrag);
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        // console.log('shouldComponentUpdate', nextProps, nextState);
        
        if (nextProps.currentTool !== this.props.currentTool) {
            this.handleToolChanged(this.props.currentTool, nextProps.currentTool);
            return true;
        }

        // isGrabbable: state.cursor.isGrabbable,
        // isGrabbing: state.cursor.isGrabbing,
        // isZooming: state.cursor.isZooming,

        if (this.state.isNavigating !== nextState.isNavigating
            || this.state.isShowingAll !== nextState.isShowingAll
            || this.state.prevBounds !== nextState.prevBounds
            || nextProps.isGrabbing !== this.props.isGrabbing
            || nextProps.isGrabbable !== this.props.isGrabbable
            
            ) {
            return true;
        }

        if (nextProps.content.selection.length !== this.props.content.selection.length) {
            return true;
        } 
        else if (nextProps.content.selection.join('_') !== this.props.content.selection.join('_')) {
            return true;
        }
        else if (nextProps.marquee !== this.props.marquee) {
            return true;
        }
        else if (nextProps.zoomTo !== this.props.zoomTo) {
            return true;
        }
        else if (nextProps.notecardPreview !== this.props.notecardPreview) {
            return true;
        }
        else if ((nextProps.content.selection.length > 1)
            && (this.props.panX !== nextProps.panX
                || this.props.panY !== nextProps.panY
                || this.props.scale !== nextProps.scale))
        {
            return true;
        } else if (this.props.media && nextProps.media) {

            for (let i in nextProps.media) {
                let itemA = nextProps.media[i];
                let itemB = this.props.media[i];
                
                // console.log('666', itemA, itemB)
                if (itemA == undefined ||
                    itemB == undefined ||
                    itemA.x != itemB.x
                || itemA.y != itemB.y
                || itemA.width != itemB.width
                || itemA.height != itemB.height
                )
                {
                    return true
                }
            }
        }

        return false;
    }

    render() {
        // console.log('render app');

        const zoomToIndicator = this.getZoomToIndicator(this.props.zoomTo);
        const marqueeIndicator = this.getMarqueeIndicator(this.props.marquee);
        const notecardPreview = this.getNotecardPreviewIndicator(this.props.notecardPreview);
        let hoverIndicator;
        let multiselectIndicator;
        let multiResizeControl;

        let isResizing;
        let isMultiselectResizing;

        /*
            This seems busted
        */

        this.props.media.map((item) => {
            if (item.editing) {
                isResizing = true;
                return;
            }
        });

        if (this.props.content.selection.length > 0) { 
            if (this.resizeHandle !== null) {
                isResizing = true;
            }
        }




        if (this.props.content.selection.length > 1) {
            const bounds = getBounds(this.props.media, this.props.content.selection);
            
            if (this.props.content.hover.length >= 1
                && this.props.content.selection.indexOf(this.props.content.hover[0]) !== -1) {
                hoverIndicator = this.getHighlight(bounds, 1, HOVER_COLOR);
            }

            multiselectIndicator = this.getHighlight(bounds, 5, SELECT_COLOR);
            multiResizeControl = this.getMultiResizeControl(bounds);

            isMultiselectResizing = true;
            //console.log('this.props.content.selection');//, this.props.content.selection);
        }

        let containerClass = ['fillContainer'];

        if (this.props.currentTool=='ZOOM') {
            containerClass.push('zoomTo');
        } else if (marqueeIndicator) {
            containerClass.push('marquee');
        } else if (!this.props.isGrabbing 
            && this.props.multiselect
            && this.props.content.hover.length == 1) {

                if (this.props.content.selection.indexOf(this.props.content.hover[0]) == -1) {
                    containerClass.push('add');
                } else {
                    containerClass.push('remove');
                }

        } else if (this.props.isGrabbing) {
            containerClass.push('grabbing');
        } else if (this.props.isGrabbable) {
            containerClass.push('grab');
        } else if (this.props.isZooming == 1) {
            containerClass.push('zoomIn');
        } else if (this.props.isZooming == -1) {
            containerClass.push('zoomOut');
        }


        const halfW = this.props.width/2;
        const halfH = this.props.height/2;

        const bounds = {
            minX: (-this.props.panX - halfW / this.props.scale),
            minY: (-this.props.panY - halfH / this.props.scale),
            maxX: (-this.props.panX + halfW / this.props.scale),
            maxY: (-this.props.panY + halfH / this.props.scale)
        }

        console.log('this.resizeHandle', this.resizeHandle);

        const alignments = getAlignments (this.props.media, this.props.content.selection, bounds, this.props.scale, isResizing);

        // console.log(onScreenMedia, alignments)

        // let PanZoom;
        // if (this.props.animation) {
        //     // console.log('animated zoom');
        //     PanZoom = this.animatedPanZoomComponent;
        // } else {
        //     // console.log('classic zoom');
        //     PanZoom = this.nonAnimatedPanZoomComponent;
        // }
        
        /*
            Influences on "current tool"
            1) Keyboard modifier: Spacebar to pan, CMD/CTRL/ALT/SHIFT etc
            2) Pointer input: mouse / pen / touch
            3) selection rollover + selection state
            4) Main toolbar tool
        */

        /*
            <DeviceEventInterface>
                { Persistent Navigation }
                { PanZoom }

                { Click to toggle select & edit }
                <SelectEventToAction />
                <ResizeEventToAction />
                <MarqueeToolAction />
            </DeviceEventInterface>
        */


        return <div
            key="SelectPanZoomResizeContainer"
            style={{
                background: '#333333'
            }}
            className={containerClass.join(' ')}
            ref={this.domRef}

            // unit test access
            onKeyDown={e => this.handleKeyDown(e)}
            onKeyUp={e => this.handleKeyUp(e)}
        >
            {/* Raw browser events to normalized state */}

            <PlatformEventInterface 
                eventTarget={this.eventTarget}
            />

            
            {<Grid config={gridConfig} scale={1}></Grid>}


            { this.getEnv() }
            {/*<Env></Env> */}

            {<Content
                eventSource={ this.domRef }
                selectIndicator={ this.selectIndicator }
                hoverIndicator={ this.hoverIndicator }
                resizeControl={ this.resizeControl }
                alignments={ alignments }
                isResizing= { isResizing }
            />}

            { this.props.content.selection.length > 1 ? multiselectIndicator : null }
            { this.props.content.hover.length >= 1 ? hoverIndicator: null }
            { isMultiselectResizing ? multiResizeControl : null }

            { zoomToIndicator ? zoomToIndicator : null }
            { marqueeIndicator ? marqueeIndicator : null }
            { notecardPreview ? notecardPreview : null }

            <AlignmentGuides
                alignments={ alignments }
                isResizing= { isResizing }
            ></AlignmentGuides>

{/*         
            <Navigator
                open={this.state.isNavigating} 
            >
            </Navigator>
*/}

            <ZoomToolbar
                showAll={ 
                    () => {
                        this.setState({
                            isShowingAll: true,
                            prevBounds: {
                                minX: -this.props.panX - (this.props.width/2 / this.props.scale),
                                minY: -this.props.panY - (this.props.height/2 / this.props.scale),
                                maxX: -this.props.panX + (this.props.width/2 / this.props.scale),
                                maxY: -this.props.panY + (this.props.height/2 / this.props.scale)                            
                            }
                        });

                        const bounds = getBounds(this.props.media, this.props.media.map((x)=>{
                            return x.id;
                        }));

                        // console.log('show all bounds', bounds);
     
                        this.directed.offsetX = 0;
                        this.directed.offsetY = 0;
                        
                        this.tweenZoom(bounds,
                            -(bounds.minX + bounds.maxX)/2, 
                            -(bounds.minY + bounds.maxY)/2,
                            20
                        );
                    }
                }
                showPrev={
                    () => {
                        this.setState({
                            isShowingAll: false
                        });

                        const bounds = this.state.prevBounds;
    
                        this.directed.offsetX = 0;
                        this.directed.offsetY = 0;
                        
                        this.tweenZoom(bounds,
                            -(bounds.minX + bounds.maxX)/2, 
                            -(bounds.minY + bounds.maxY)/2
                        );
                    }
                }
                setZoom={
                    (n)=>{
                        // console.log('component prop set zoom', n)
                        this.directed.scale = n;
                        this.startAnimation();
                    }
                }
                resetZoom={
                    ()=>{
                        // console.log('component prop reset zoom')
                        this.directed.scale = defaultZoom;
                        this.startAnimation();
                    }
                }
                
                isShowingAll={this.state.isShowingAll}

            />


            {/* <Toolbar config={{}}
                zoomTo={ 
                    (x) => {
                        // console.log('ZOOM TOOO!', x)
                        this.directed.scale = x;            
                        this.directed.offsetX = 0;
                        this.directed.offsetY = 0;
            
                        this.startAnimation();
                    }
                }
            >
                <Version />
                <FPSStats 
                    top="auto"
                    left="auto"

                    bottom="0"
                    left="0"
                />
            </Toolbar> */}

            <FPSStats 
                top="auto"
                left="auto"

                bottom="0"
            />



            
        </div>
    }
}




SelectPanZoomResize.displayName = "SelectPanZoomResizeComponent";

// const mediaSelector = state => state.content.media;
// export const getMediaSelector = createSelector(mediaSelector, content => {
//     // console.log('selector media', content);
//     return content;
// });


const mapStateToProps = (state, ownProps) => {
    // console.log(state);

    return Object.assign({}, { 
        content: state.content,
        media: state.content.media, //getMediaSelector(state), // state.content.media, //
        env: state.env,
        // z: state.camera.zoom,
        // zError: state.camera.zoomError,
        width: state.camera.size.width, 
        height: state.camera.size.height, 
        panX: state.camera.pan.x, 
        panY: state.camera.pan.y,
        scale: state.camera.zoom,

        isGrabbable: state.cursor.isGrabbable,
        isGrabbing: state.cursor.isGrabbing,
        isZooming: state.cursor.isZooming,

        marquee: state.tool.marquee,
        zoomTo: state.tool.zoomTo,
        notecardPreview: state.tool.notecardPreview,
        multiselect: state.tool.multiselect,
        currentTool: state.tool.current,
        aspectLock: state.tool.aspectLock

    }, ownProps);
}

const ConnectedComponent = connect(
    mapStateToProps,
    {
        ...contentActions,
        ...panZoomActions,
        ...selectionActions,
        ...editActions,
        ...toolActions,
        ...cursorActions,
        ...hoverActions,
        ...notecardActions
    }
)(SelectPanZoomResize);
ConnectedComponent.displayName = "SelectPanZoomResize";

export default ConnectedComponent;
export { SelectPanZoomResize as SelectPanZoomResizeComponent };